import { gql } from '@apollo/client';
import { AdminLayout } from 'components/admin/admin-layout';
import { useInput } from 'lib/hooks/use-input';
import { useInsertNewVoucherMutation } from 'lib/graphql-generated';
import { Button } from 'components/buttons/button';
import currency from 'currency.js';
import { useRouter } from 'next/router';
import { emailRegex } from 'lib/utils';
import { isNumber } from 'lodash';

const INSERT_VOUCHER = gql`
  mutation InsertNewVoucher($data: vouchers_insert_input!) {
    insert_vouchers_one(object: $data) {
      id
    }
  }
`;

export const NewVoucher = () => {
  const router = useRouter();
  const amount = useInput<number>(0);
  const email = useInput<string>('');
  const isSaveDisabled =
    currency(amount.value).intValue <= 0 ||
    !isNumber(currency(amount.value).intValue) ||
    amount.value === null ||
    email.value.trim() === '' ||
    !emailRegex.test(email.value);

  const [save] = useInsertNewVoucherMutation();

  const handleSave = (e) => {
    e.preventDefault();
    save({
      variables: {
        data: {
          initial_amount: currency(amount.value).intValue,
          recipient: email.value,
        },
      },
    }).then(({ data }) => {
      router.push(`/admin/vouchers/${data.insert_vouchers_one.id}`);
    });
  };

  return (
    <>
      <AdminLayout page='New Voucher'>
        <article className='space-y-4'>
          <header className='flex flex-row justify-between'>
            <h1 className='header text-4xl'>Creating New Voucher</h1>
            <section className='space-x-4'>
              <Button
                buttonType='primary'
                buttonSize='md'
                disabled={isSaveDisabled}
                onClick={handleSave}>
                Save
              </Button>
              <Button buttonType='ghost' buttonSize='md' href='/admin/vouchers'>
                Cancel
              </Button>
            </section>
          </header>
          <form
            className='flex flex-row flex-wrap w-full space-y-4 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-4 xl:gap-8'
            onSubmit={handleSave}>
            <label htmlFor='title' className='w-full flex flex-col'>
              Initial Amount
              <input type='text' name='title' id='title' {...amount.bind} />
            </label>
            <label htmlFor='email' className='w-full flex flex-col'>
              Recipient
              <input type='email' id='email' name='email' {...email.bind} />
            </label>
          </form>
        </article>
      </AdminLayout>
    </>
  );
};

export default NewVoucher;
